import { AppState } from '@/store/gameStore';
import {
  enterTable,
  goTutorial,
  claimDaily,
  canClaimDaily,
  today,
} from '@/store/gameStore';
import { TABLES } from '@/engine/economy';
import { canEnter } from '@/engine/economy';
import { renderTile } from './tiles';
import { fmt } from './format';
import { isMuted, toggleMuted, sound, isMusicOn, toggleMusic } from './sound';

export function renderLobby(state: AppState): HTMLElement {
  const root = document.createElement('div');
  root.appendChild(topbar(state));

  const screen = document.createElement('div');
  screen.className = 'screen';
  root.appendChild(screen);

  // hero
  const hero = document.createElement('div');
  hero.className = 'hero';
  hero.innerHTML = `
    <div class="hero__brand">majak<span class="dot">.</span></div>
    <p class="hero__sub">고스톱처럼 배우고, 가상머니 걸고 겨루는 일본식 마작</p>
  `;
  const motif = document.createElement('div');
  motif.className = 'hero__tiles';
  [0, 4, 8, 27, 33].forEach((t, i) =>
    motif.appendChild(renderTile(t, { size: 'lg', dora: t === 33, rotated: i === 4 })),
  );
  hero.appendChild(motif);
  screen.appendChild(hero);

  // actions: tutorial + daily
  const actions = document.createElement('div');
  actions.className = 'lobby-actions';
  const tut = btn('튜토리얼로 배우기', 'btn btn--primary');
  tut.onclick = goTutorial;
  actions.appendChild(tut);

  const claimable = canClaimDaily(today());
  const daily = btn(claimable ? '데일리 보너스 +5,000' : '오늘 보너스 받음', 'btn btn--gold');
  daily.disabled = !claimable;
  daily.onclick = () => claimDaily(today());
  actions.appendChild(daily);
  screen.appendChild(actions);

  // tables
  const title = document.createElement('h2');
  title.className = 'section-title';
  title.textContent = '테이블 선택';
  screen.appendChild(title);

  const grid = document.createElement('div');
  grid.className = 'tables';
  for (const table of TABLES) {
    const open = canEnter(state.wallet.balance, table);
    const card = document.createElement('button');
    card.className = 'table-card';
    card.disabled = !open;
    card.innerHTML = `
      <div class="table-card__name">${table.name}</div>
      <div class="table-card__rate">1점 = ${table.rate.toLocaleString()}원</div>
      ${
        open
          ? `<div class="table-card__req">최소 보유 ${fmt(table.minBalance)} · 바이인 ${fmt(table.buyIn)}</div>`
          : `<div class="table-card__locked">🔒 ${fmt(table.minBalance)} 이상 보유 시 해금</div>`
      }
    `;
    if (open) card.onclick = () => enterTable(table.id);
    grid.appendChild(card);
  }
  screen.appendChild(grid);

  return root;
}

export function topbar(state: AppState): HTMLElement {
  const bar = document.createElement('div');
  bar.className = 'topbar';
  const mark = document.createElement('div');
  mark.className = 'wordmark';
  mark.innerHTML = 'majak<span class="dot">.</span>';
  bar.appendChild(mark);

  const right = document.createElement('div');
  right.style.cssText = 'display:flex;align-items:center;gap:10px';
  right.appendChild(musicToggle());
  right.appendChild(soundToggle());
  const chip = document.createElement('div');
  chip.className = 'wallet-chip';
  chip.innerHTML = `<span class="label">보유</span> ${fmt(state.wallet.balance)}`;
  right.appendChild(chip);
  bar.appendChild(right);
  return bar;
}

/** 효과음 음소거 토글 — 자체적으로 아이콘 갱신. */
export function soundToggle(): HTMLButtonElement {
  const b = document.createElement('button');
  b.className = 'btn btn--ghost sound-toggle';
  const paint = () => {
    b.textContent = isMuted() ? '🔇' : '🔊';
    b.title = isMuted() ? '효과음 켜기' : '효과음 끄기';
    b.setAttribute('aria-label', isMuted() ? '효과음 켜기' : '효과음 끄기');
  };
  paint();
  b.onclick = () => {
    toggleMuted();
    paint();
    if (!isMuted()) sound.button();
  };
  return b;
}

/** 배경음악 토글. */
export function musicToggle(): HTMLButtonElement {
  const b = document.createElement('button');
  b.className = 'btn btn--ghost sound-toggle';
  const paint = () => {
    b.textContent = '🎵';
    b.style.opacity = isMusicOn() ? '1' : '0.4';
    b.style.filter = isMusicOn() ? 'none' : 'grayscale(1)';
    b.title = isMusicOn() ? '배경음악 끄기' : '배경음악 켜기';
    b.setAttribute('aria-label', isMusicOn() ? '배경음악 끄기' : '배경음악 켜기');
  };
  paint();
  b.onclick = () => {
    toggleMusic();
    paint();
  };
  return b;
}

function btn(label: string, cls: string): HTMLButtonElement {
  const b = document.createElement('button');
  b.className = cls;
  b.textContent = label;
  return b;
}
